import { defineStore } from "pinia";
import type { RouteLocationNormalizedLoaded } from "vue-router";

interface ISearchStoreState {
    searchFormParams: Record<string, any>;
    fromPath: RouteLocationNormalizedLoaded | Record<string, any>;
    // 捡漏商品订单确认页，缓存订单信息
    bargainConfirmOrder: Record<string, string | number | undefined>;
}

export const useSearchPrams = defineStore("zhihao-web-searchParams", {
    state: (): ISearchStoreState => ({
        searchFormParams: {},
        fromPath: {},
        // 捡漏商品订单确认页，缓存订单信息
        bargainConfirmOrder: {}
    }),
    getters: {
        fromPage: state => state.fromPath
    },
    actions: {
        setSearchFormParams(menuName: string, params: Record<string, any>) {
            this.searchFormParams[menuName] = { ...params };
        },
        setConfirmOrderDialog(params: Record<string, string | number | undefined>) {
            this.bargainConfirmOrder = params;
        },
        setFromPath(fromPath: RouteLocationNormalizedLoaded) {
            this.fromPath = fromPath;
        },
        clearParams() {
            this.searchFormParams = {};
        },
        clearConfirmOrderDialog() {
            this.bargainConfirmOrder = {};
        }
    },
    persist: true
});
